module.exports = __webpack_public_path__ + "media/packs/images/flags/ID-34bdb0051e8a90665c6ffd888ca3be8a.svg";